<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('admin.favorites.detail.back') }}</span>
    </div>
    <a-tabs @change="callback">
      <a-tab-pane key="1" :tab="$t('admin.favorites.detail.tabs.likes')" forceRender="true">
        <Like></Like>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('admin.favorites.detail.tabs.collections')" forceRender="true">
        <Collet></Collet>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Like from './like.vue'
import Collet from './collet.vue'

export default {
  components: {
    Like,
    Collet
  },
  data() {
    return {}
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.$router.back()
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  margin-top: 20px;

  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/ .ant-tabs-top .ant-tabs-ink-bar-animated{
  display: none !important;
}
/deep/ .ant-tabs-bar{
  border: none;
}
/deep/ .ant-tabs-nav{
  background: #EDF3FA;
  border-radius: 6px;
  .ant-tabs-tab{
    color: #6B738C;
    margin-right: 0;
    padding: 10px 27px;
  }
  .ant-tabs-tab-active{
    color: #FFF;
    background-color: #F27529;
    border-radius: 6px;
  }
}
</style>
